import { render, staticRenderFns } from "./ParkersLogo.vue?vue&type=template&id=20bdb348&scoped=true"
import script from "./ParkersLogo.vue?vue&type=script&lang=js"
export * from "./ParkersLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdb348",
  null
  
)

export default component.exports